import { registerPlugin } from '@capacitor/core';

/**
 * Puente del instalador de APK (`android/…/update/RoisAppUpdatePlugin.java`).
 *
 * Solo se usa cuando cambia la capa NATIVA. Los cambios de la capa web se
 * entregan por OTA (`src/utils/appUpdate.ts`) sin tocar el APK.
 */
export interface RoisAppUpdatePlugin {
  /** ¿Tiene la app permiso para instalar paquetes? Android 8+ lo concede app por app. */
  canInstall(): Promise<{ allowed: boolean }>;
  /** Abre los ajustes del sistema donde se concede ese permiso. */
  openInstallSettings(): Promise<void>;
  /**
   * Descarga el APK, verifica su checksum y lanza el instalador de Android.
   * Si el checksum no cuadra, borra el fichero y rechaza: instalar un paquete
   * que no es exactamente el publicado sería el peor fallo posible.
   *
   * Rechaza con `INSTALL_CANCELLED` si el operario cancela en la pantalla de
   * Android. Saberlo importa: con una actualización obligatoria hay que volver
   * a insistir en vez de esperar un reinicio que no llegará.
   */
  downloadAndInstall(options: {
    url: string;
    checksum?: string;
  }): Promise<{ status: 'installed'; message?: string }>;
  addListener(
    eventName: 'downloadProgress',
    listenerFunc: (progress: { percent: number }) => void
  ): Promise<{ remove: () => Promise<void> }>;
}

export const RoisAppUpdate = registerPlugin<RoisAppUpdatePlugin>('RoisAppUpdate');
export default RoisAppUpdate;
